<app-widget titleT="PROJECTS.cockpit.project-widget.title" [itemsCount]="(totalCount$ | async)!"
    [navigateLink]="['/', 'customer-spaces', customerSpaceId, 'projects']"
    [loading]="(loadingService.loading$ | async)!">
    <div *appShowAuthorize="'PROJECT_CREATE'; options: { values: { customerSpaceId: customerSpaceId } }"
        class="slot-action-button">
        <app-button-icon-add (click)="navigation.navigateCreateProject(customerSpaceId)"
            tooltip="Requires PROJECT_CREATE" />
    </div>

    <app-project-widget-table [projects$]="projectItems$" [displayRowsCount]="6" [customerSpaceId]="customerSpaceId"
        [isInternalUser]="isInternalUser" (numberClicked)="onProjectNumbersClick($event)" />

    <div class="overlay" *ngIf="showOverlay"></div>
</app-widget>